import { css } from '@emotion/react'
import { colors, font } from 'plume-ui'

export const ConditionTitle: React.FC<{ title: string }> = (props) => {
  return (
    <p
      className="conditions-label"
      css={css`
        margin: 0;
        margin-block-start: 4px;
        color: ${colors.textLight};
        font-size: 12px;
        font-weight: ${font.weight.bold};
        line-height: 1.25;
        letter-spacing: 0.02em;
      `}
    >
      {props.title}
    </p>
  )
}
